import { Mui } from "@osu/react-ui";
import { Fragment } from "react";
import { BOOL } from "../../util/constants";
import { dropdownSubtypes, inputMappings } from "../../util/enums";

export const formSections = [
  {
    id: "form",
    questions: [
      {
        id: "completion-term",
        type: inputMappings.dropDown,
        subtype: dropdownSubtypes.term,
        title: "Completion Term",
        dataField: "termCode",
        required: true,
        filter: {
          showFromPresent: 2
        }
      },
      {
        id: "end-of-semester-option",
        summary: (
          <Fragment>
            <Mui.Typography variant="body2">
              The End of Semester (EOS) option you have selected means that the certificate 
              will not be awarded in the semester selected on the form.  The certificate 
              will be awarded in the following semester.  This is the only option available 
              if the Application for Certificate Completion for a given semester is submitted 
              after the application deadline for that semester has passed. Ex., if a student 
              selects autumn EOS, then the certificate will be awarded at the end of the following 
              spring semester if all requirements are successfully completed.
            </Mui.Typography>
          </Fragment>
        ),
        type: inputMappings.checkbox,
        dataField: "endOfSemesterOption",
        defaultValue: BOOL.NO,
        choices: [
          {
            id: "end-of-semester-option-yes",
            title: "End of Semester Option",
            value: BOOL.YES,
            branch: "end-of-semester-confirmation"
          }
        ]
      },
      {
        id: "end-of-semester-confirmation",
        title: "End of Semester Confirmation",
        type: inputMappings.checkbox,
        dataField: "endOfSemesterConfirmation",
        defaultValue: BOOL.NO,
        dependencies: ["end-of-semester-option"],
        required: true,
        summary: "In selecting the end of semester option for the semester indicated on this application I understand that the certificate will be awarded in the following semester if all requirements are completed by the respective end of semester deadline.",
        choices: [
          {
            id: "end-of-semester-confirmation-yes",
            value: BOOL.YES,
            title: "Confirm"
          }
        ]
      },
      {
        id: "certificate-plan",
        type: inputMappings.dropDown,
        dataField: "academicPlan",
        subtype: dropdownSubtypes.certicatePlans,
        title: "Certificate Plan",
        required: true
      },
      {
        id: "courses-input-group",
        title: "Courses",
        type: inputMappings.inputGroup,
        numberOfResponsesMinimum: 1,
        numberOfResponsesMaximum: 10,
        dataField: "courses",
        required: true,
        questions: [
          {
            id: "courses-ig-department",
            type: inputMappings.textInput,
            title: "Department",
            summary: null,
            required: true,
            dataField: "department",
            gridProps: {
              xs: 12,
              sm: 8,
              md: 4
            }
          },
          {
            id: "courses-ig-number",
            type: inputMappings.textInput,
            title: "Course Number",
            dataField: "courseNumber",
            summary: null,
            required: true,
            gridProps: {
              xs: 12,
              sm: 4,
              md: 2
            }
          },
          {
            id: "courses-ig-title",
            type: inputMappings.textInput,
            title: "Course Title",
            dataField: "courseTitle",
            summary: null,
            required: true,
            gridProps: {
              xs: 12,
              sm: 8,
              md: 4
            }
          },
          {
            id: "courses-ig-credit-hours",
            type: inputMappings.numberInput,
            title: "Credit Hours",
            dataField: "creditHours",
            summary: null,
            required: true,
            gridProps: {
              xs: 12,
              sm: 4,
              md: 2
            },
            inputProps: {
              min: 0
            }
          }
        ]
      }
    ]
  }
];

export const filters = [
  {
    id: "term",
    type: inputMappings.dropDown,
    subtype: dropdownSubtypes.term,
    title: "Completion Term",
    required: true,
    filter: {
      showFromPresent: 2
    }
  }
]

export const additionalFilters = [];